import Vue from 'vue';
import eventHub from '@/helpers/event-hub';
import {
  isReachable,
  handleConnectivity,
  CONNECTIVITY_STATUSES,
} from '@/helpers';

import 'reset-css';
import 'hamburgers/dist/hamburgers.min.css';
import '@/registerPlugins';
import '@/assets/styles/general.styl';

import App from '@/App.vue';
import VueBodyClass from 'vue-body-class';

import router from '@/router/';
import store from '@/store';
import '@/filters';
import '@/registerServiceWorker';
import '@/registerGlobalComponents';

import Api from '@/services';
import i18n from '@/localization';
import '@/validations';
import config from '@/config';

// Helpers functions on app init
import { localStorageUserSetUp } from '@/helpers/local.storage.setup';

Vue.use(VueBodyClass, router);

// Add services wrapper to Vue instance
Vue.prototype.$api = Api;
Vue.prototype.$appConfig = config;
Vue.prototype.$eventHub = eventHub;

Vue.config.productionTip = false;

window.addEventListener('load', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  store.dispatch(
    'changeConnectivity',
    navigator.onLine
      ? CONNECTIVITY_STATUSES.ONLINE
      : CONNECTIVITY_STATUSES.OFFLINE
  );
  window.addEventListener('online', () => {
    if (navigator.onLine) {
      isReachable(window.location.origin)
        .then(function(online) {
          if (online) {
            store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.ONLINE);
          } else {
            store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.OFFLINE);
          }
        })
        .catch(() => {
          store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.OFFLINE);
        });
    } else {
      store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.OFFLINE);
    }
  });
  window.addEventListener('offline', () => {
    if (navigator.onLine) {
      isReachable(window.location.origin)
        .then(function(online) {
          if (online) {
            store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.ONLINE);
          } else {
            store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.OFFLINE);
          }
        })
        .catch(() => {
          store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.OFFLINE);
        });
    } else {
      store.dispatch('changeConnectivity', CONNECTIVITY_STATUSES.OFFLINE);
    }
  });
});

localStorageUserSetUp().then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app');
});
